<template>
  <div class="card-development-container">
    <!-- Header Title -->
    <div class="development-header-wrapper mb-16">
      <h4 class="development-title mb-10">Development Log</h4>
    </div>

    <!-- Development Log & HRD Budget Card -->
    <a-card :bordered="false" class="header-solid development-card" :bodyStyle="{ padding: '24px' }">
      <!-- Log Lists -->
      <div class="logs-content">
        <!-- HRD Budget Category -->
        <div class="log-category-group mb-16">
          <div class="category-header">
            <span class="category-bullet">&bull;</span>
            <span class="category-name">HRD Budget</span>
          </div>
          <ul v-if="logData.hrdBudget && logData.hrdBudget.length > 0" class="sub-log-list">
            <li v-for="(item, index) in logData.hrdBudget" :key="'hrd-log-' + index" class="sub-log-item">
              <span class="sub-bullet">&#9702;</span>
              <span class="log-year">{{ item.year }} :</span>
              <span class="log-desc">{{ item.text }}</span>
            </li>
          </ul>
          <div v-else class="empty-log-text font-web text-muted ml-24 mt-4">
            ยังไม่มีข้อมูล
          </div>
        </div>

        <!-- Others Category -->
        <div class="log-category-group">
          <div class="category-header">
            <span class="category-bullet">&bull;</span>
            <span class="category-name">Others</span>
          </div>
          <ul v-if="logData.others && logData.others.length > 0" class="sub-log-list">
            <li v-for="(item, index) in logData.others" :key="'oth-log-' + index" class="sub-log-item">
              <span class="sub-bullet">&#9702;</span>
              <span class="log-year">{{ item.year }} :</span>
              <span class="log-desc">{{ item.text }}</span>
            </li>
          </ul>
          <div v-else class="empty-log-text font-web text-muted ml-24 mt-4">
            ยังไม่มีข้อมูล
          </div>
        </div>
      </div>

      <!-- HRD Budget Section (Future Feature) -->
      <div class="hrd-budget-widget-section mt-24">
        <h4 class="hrd-section-title mb-12">HRD Budget</h4>

        <div class="hrd-progress-row">
          <div class="hrd-progress-track" :class="{ 'has-budget': budgetInfo.total > 0 }">
            <div class="hrd-progress-fill" :style="{ width: progressPercentage + '%' }"></div>
          </div>
          <div class="hrd-percentage-text">{{ progressPercentage }}%</div>
        </div>

        <div class="hrd-amount-row mt-6">
          <span class="hrd-amount-text font-web">
            ยอดเงินรวมที่ขอเบิก HRD Budget ไปทั้งสิ้น {{ formatCurrency(budgetInfo.used) }}/{{
              formatCurrency(budgetInfo.total) }} บาท
          </span>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'CardDevelopment',
  props: {
    dataLogs: {
      type: Object,
      default: () => ({
        hrdBudget: [],
        others: [],
      }),
    },
    dataBudget: {
      type: Object,
      default: () => ({
        used: 0,
        total: 0,
        percentage: 0,
      }),
    },
    selectedYear: {
      type: Number,
      default: null,
    },
  },
  computed: {
    logData() {
      return {
        hrdBudget: (this.dataLogs && this.dataLogs.hrdBudget) || [],
        others: (this.dataLogs && this.dataLogs.others) || [],
      };
    },
    budgetInfo() {
      return (
        this.dataBudget || {
          used: 0,
          total: 0,
          percentage: 0,
        }
      );
    },
    progressPercentage() {
      if (this.budgetInfo.percentage !== undefined) {
        return this.budgetInfo.percentage;
      }
      if (this.budgetInfo.total > 0) {
        return Math.round((this.budgetInfo.used / this.budgetInfo.total) * 100);
      }
      return 0;
    },
  },
  methods: {
    formatCurrency(val) {
      if (val === undefined || val === null) return '0';
      return val.toString();
    },
  },
};
</script>

<style scoped>
.card-development-container {
  width: 100%;
}

.development-header-wrapper {
  display: flex;
  align-items: center;
  min-height: 38px;
}

.development-title {
  font-size: 20px;
  font-weight: 700;
  color: #111111;
  line-height: 1.2;
}

.development-card {
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* Category & Lists */
.log-category-group {
  font-family: inherit;
}

.category-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  color: #111111;
  margin-bottom: 6px;
}

.category-bullet {
  font-size: 20px;
  line-height: 1;
  margin-right: 8px;
  color: #111111;
}

.sub-log-list {
  list-style: none;
  padding-left: 20px;
  margin: 0;
}

.sub-log-item {
  display: flex;
  align-items: baseline;
  margin-bottom: 6px;
  font-size: 13.5px;
  line-height: 1.45;
  color: #333333;
}

.sub-bullet {
  font-size: 16px;
  line-height: 1;
  margin-right: 8px;
  color: #555555;
  flex-shrink: 0;
}

.log-year {
  font-weight: 700;
  color: #111111;
  margin-right: 6px;
  flex-shrink: 0;
}

.log-desc {
  color: #444444;
}

.empty-log-text {
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.4;
}

/* HRD Budget Section */
.hrd-budget-widget-section {
  padding-top: 16px;
}

.hrd-section-title {
  font-size: 19px;
  font-weight: 700;
  color: #111111;
}

.hrd-progress-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.hrd-progress-track {
  flex: 1;
  height: 28px;
  border-radius: 14px;
  background-color: #edeef5;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
}

.hrd-progress-track.has-budget {
  background-color: #5832e5;
}

.hrd-progress-fill {
  height: 100%;
  background-color: #f9ba48;
  border-radius: 14px 0 0 14px;
  transition: width 0.5s ease;
}

.hrd-percentage-text {
  font-size: 32px;
  font-weight: 700;
  color: #111111;
  line-height: 1;
  min-width: 65px;
  text-align: right;
  letter-spacing: -0.5px;
}

.hrd-amount-row {
  display: flex;
  align-items: center;
}

.hrd-amount-text {
  font-size: 14px;
  font-weight: 600;
  color: #222222;
}
</style>
